(function(){
    'use strict';
    
    /*==---------------------------------------------------------====
        Global Alerts
    ====---------------------------------------------------------====
        Check the alert state of the session storage variable and 
        only display it if the state does not equal "closed"
    ====---------------------------------------------------------==*/
    
    function initGlobalAlert() {
        
        var alertKey = $(".global-alert").attr('data-key');

        if (alertKey !== null) {
            var windowClosed = sessionStorage.getItem("alertState_" + alertKey);

            if ( windowClosed === "closed" ) {
                $(".global-alert").remove();
            } else  {
                showAlert(alertKey);
            }
        } else {
            showAlert();
        }
    };

    function showAlert(alertKey) {
        $(".global-alert").show();
        $(".close-alert").click(function() {
            if (alertKey !== null) {
                sessionStorage.setItem("alertState_" + alertKey, "closed");
            }
            $(".global-alert").slideUp(150);
        });
    }

    $(document).ready(function() {
        initGlobalAlert();
    });

}());
